var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('simple-button', {
    directives: [{
      name: "p-t",
      rawName: "v-p-t",
      value: 20,
      expression: "20"
    }, {
      name: "p-b",
      rawName: "v-p-b",
      value: 20,
      expression: "20"
    }, {
      name: "f-size",
      rawName: "v-f-size",
      value: '14px',
      expression: "'14px'"
    }, {
      name: "color",
      rawName: "v-color:violet",
      arg: "violet"
    }],
    attrs: {
      "variant": "transparent"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('base-icon', {
    directives: [{
      name: "m-r",
      rawName: "v-m-r",
      value: 10,
      expression: "10"
    }],
    attrs: {
      "name": "basic_send"
    }
  }), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('common.receipt'))
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }